<ng-template #rowTemplate let-node="node" let-depth="depth">
  <tr *ngIf="matchesSearch(node)">
    <td class="text-right">
      <fa-icon
        *ngIf="node.children?.length > 0 && search.length === 0"
        style="cursor: pointer"
        [icon]="showChildren[node.uuid] ? 'minus' : 'plus'"
        (click)="showChildren[node.uuid] = !!!showChildren[node.uuid]"
      ></fa-icon>
    </td>
    <td
      *ngIf="search.length === 0"
      [class]="'p-l-' + depth"
      colspan="2"
      style="cursor: pointer"
      (click)="showChildren[node.uuid] = !!!showChildren[node.uuid]"
    >
      {{node.name}}
    </td>
    <td *ngIf="search.length > 0" colspan="2">{{ prettyPath(node) }}</td>
    <td class="text-center">
      <div class="d-flex justify-content-center form-check form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          id="form-notes-switch"
          [ngModel]="node.hasResource('CHAT')"
          [ngModelOptions]="{standalone: true}"
          (change)="toggleNode(node)"
        />
      </div>
    </td>
  </tr>

  <ng-container *ngIf="showChildren[node.uuid] || search.length > 0">
    <ng-container
      *ngFor="let child of node.children; trackBy: trackByUUID"
      [ngTemplateOutlet]="rowTemplate"
      [ngTemplateOutletContext]="{node: child, depth: depth + 1}"
    ></ng-container>
  </ng-container>
</ng-template>

<table class="table">
  <thead>
    <tr>
      <th style="width: 2.5em"></th>
      <th class="text-start p-l-0">Name</th>
      <th><input class="form-control" type="text" placeholder="Search" [(ngModel)]="search" name="tile" /></th>
      <th class="text-center" ngbTooltip="Enable Chat on this Node.">Chat</th>
    </tr>
  </thead>
  <tbody>
    <ng-container
      *ngFor="let child of root.children; trackBy: trackByUUID"
      [ngTemplateOutlet]="rowTemplate"
      [ngTemplateOutletContext]="{node: child, depth: 0}"
    ></ng-container>
  </tbody>
</table>
